import { IMovieActivity } from "src/lib/filmwebid/IMovieActivity";
import { useUserApiQuery } from "src/lib/filmwebid/useUserApiQuery";
import { useCallback, useState } from "react";

export default function useMovieActivity(edi: string | undefined | null, streamingId: string | number | undefined | null)
	: [activity: IMovieActivity | null, updater: () => void, isLoading: boolean] {

	const enabled = Boolean(edi || streamingId);
	const { data, isLoading, refetch } = useUserApiQuery<IMovieActivity>(
		"/api/Movie/MovieActivity",
		{ edi, streamingId },
		{ method: "GET", allowAnon: true },
		{
			enabled,
			refetchOnWindowFocus: false,
			staleTime: 0,
		}
	);

	const movieActivity = data ?? null;

	return [movieActivity, refetch, isLoading];
}